import React from 'react';
import Menu3 from '../../components/MenuElements/Menu3';
import Takeout from '../../components/MenuElements/Takeout';
import PageHeader from '../Shared/PageHeader';

const Menu03 = () => {
    return (
        <div>
            <PageHeader title="Our Menu"></PageHeader>
            <Menu3></Menu3>
            <Takeout></Takeout>
        </div>
    );
};

export default Menu03;